export const getCategoryItems = (categories, categoryId, items) => (
  categoryId
    ? categories.byId[categoryId].itemIds.map(itemId => ({
      name: items[itemId].name,
      id: itemId,
    }))
    : []);

export const getSubcategoryItems = (subcategoryId, items) => (
  subcategoryId
    ? Object.keys(items).reduce((acc, itemId) => {
      if (items[itemId].subcategoryId === subcategoryId) {
        acc.push({
          name: items[itemId].name,
          id: parseInt(itemId, 10),
        });
      }
      return acc;
    }, [])
    : []);

export const getCategorySubcategories = (subcategories, categories, categoryId) => (
  categoryId
    ? categories.byId[categoryId].subcategoryIds.map(id => ({
      name: subcategories[id].name,
      id,
    }))
    : []);

export const getCategories = categories => (
  categories.sortedIds.map(categoryId => ({
    name: categories.byId[categoryId].name,
    id: categoryId,
  })));

export const getCategorySizes = (categoryId, categories, items, sizes) => {
  const categorySizes = [];
  categories.byId[categoryId]?.itemIds.forEach(itemId => {
    items[itemId].sizeIds.forEach(sizeId => {
      if (!categorySizes.find(categorySize => categorySize.name === sizes[sizeId].name)) {
        categorySizes.push({
          id: sizeId,
          name: sizes[sizeId].name,
          price: sizes[sizeId].price,
        });
      }
    });
  });

  return categorySizes;
};

export const getSubcategorySizes = (subcategoryId, items, sizes) => {
  const subcategorySizes = [];
  Object.keys(items).forEach(itemId => {
    if (items[itemId].subcategoryId === subcategoryId) {
      items[itemId].sizeIds.forEach(sizeId => {
        if (!subcategorySizes.find(subcategorySize => subcategorySize.name === sizes[sizeId].name)) {
          subcategorySizes.push({
            id: sizeId,
            name: sizes[sizeId].name,
            price: sizes[sizeId].price,
          });
        }
      });
    }
  });

  return subcategorySizes;
};

export const getCategoryAvailabilities = (categories, categoryId, availabilities) => (
  categories.byId[categoryId].availabilityIds.map(id => (
    availabilities[id]
  )));

export const getCategorySpecials = (specialsCategory, categories, categoryId) => (
  categories.byId[categoryId]?.specialIds.map(id => ({
    id,
    ...specialsCategory[id],
  })));

export const getSubcategoryAvailabilities = (subcategories, subcategoryId, availabilities) => (
  subcategories[subcategoryId].availabilityIds.map(id => (
    availabilities[id]
  )));

export const getSubcategorySpecials = (specialsCategory, subcategories, subcategoryId) => (
  subcategories[subcategoryId]?.specialIds.map(id => ({
    id,
    ...specialsCategory[id],
  })));
